export default __webpack_public_path__ + "static/media/Neck.dcccbaa9.svg";